import { getLoanById } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { RiskResults } from '@/components/modules/Risk/RiskScore/components/RiskResults';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';
import { findCurrentParticipantOnboardingDetailsByOnboardingDetailsId } from '@/utils/findCurrentParticipantOnboardingDetails';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const RiskScore = () => {
  const {
    state: { applicationParticipant },
  } = usePageContext();
  const { loanId } = useParams();

  if (!loanId) return null;

  const { data: loan } = useCache(getLoanById, { loanId });

  const onboardingDetails = findCurrentParticipantOnboardingDetailsByOnboardingDetailsId({
    loan: loan,
    onboardingDetailsId: applicationParticipant.onboardingDetails?.id,
  });

  return <RiskResults loanId={loanId} onboardingDetails={onboardingDetails} />;
};

export const RiskScoreModule = withPermissionsModule(RiskScore);
